import { Badge } from "@/components/ui/badge";
import { AlertTriangle, ChevronRight, Clock } from "lucide-react";

const KIND_CLS = { Table: "bg-[#7a0f1d]", Pickup: "bg-[#0b5a2e]", Catering: "bg-[#123b8a]", Celebration: "bg-[#62115a]", Modak: "bg-[#8a4f10]" };

export function BookingTimeline({ items, onOpen }) {
  return (
    <div className="bi-panel" data-testid="bi-timeline">
      <h2 className="bi-panel-title"><Clock className="h-5 w-5" />Today's Timeline</h2>
      {!items?.length ? <p className="text-base text-muted-foreground">Nothing scheduled for this date.</p> : (
        <ol className="relative space-y-3 border-l-4 border-[#e2b85a] pl-5">
          {items.map((e, i) => (
            <li key={i} className="relative" data-testid={`bi-timeline-item-${i}`}>
              <span className={`absolute -left-[30px] top-2 h-4 w-4 rounded-full border-2 border-[#fff3c4] ${KIND_CLS[e.kind] || "bg-stone-500"}`} />
              <button type="button" onClick={() => onOpen(e.tab)} className="flex w-full flex-wrap items-center gap-3 rounded-xl bg-white p-3 text-left shadow-sm hover:bg-[#fff8e8]">
                <span className="w-28 font-semibold text-[#7a0f1d]">{e.time || "Any time"}</span>
                <Badge className={`${KIND_CLS[e.kind] || "bg-stone-500"} text-white`}>{e.kind}</Badge>
                <span className="flex-1 text-base font-medium">{e.title} <span className="text-muted-foreground">· {e.detail}</span></span>
                <span className="text-sm text-muted-foreground">{e.center} · {String(e.status || "").replace(/_/g, " ")}</span>
              </button>
            </li>))}
        </ol>)}
    </div>
  );
}

export function AttentionList({ items, onOpen }) {
  return (
    <div className="bi-panel" data-testid="bi-attention">
      <h2 className="bi-panel-title"><AlertTriangle className="h-5 w-5 text-amber-600" />Attention Required</h2>
      {!items?.length ? <p className="text-base text-emerald-700">All clear — nothing waiting.</p> : items.map((a, i) => (
        <button key={i} type="button" onClick={() => onOpen(a.tab)} className="mb-2 flex w-full items-center justify-between gap-3 rounded-xl border-2 border-amber-200 bg-amber-50 p-3 text-left text-base hover:bg-amber-100" data-testid={`bi-attention-${i}`}>
          <span>{a.label}</span><span className="flex items-center gap-1 text-xl font-bold text-[#7a0f1d]">{a.count}<ChevronRight className="h-5 w-5" /></span>
        </button>))}
    </div>
  );
}
